import { render } from "./PregUpdate.vue?vue&type=template&id=1da51d9d&scoped=true"
import script from "./PregUpdate.vue?vue&type=script&lang=js"
export * from "./PregUpdate.vue?vue&type=script&lang=js"

import "./PregUpdate.vue?vue&type=style&index=0&id=1da51d9d&scoped=true&lang=css"
import "./PregUpdate.vue?vue&type=style&index=1&id=1da51d9d&lang=css"
import "./PregUpdate.vue?vue&type=style&index=2&id=1da51d9d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da51d9d"]])

export default __exports__